import React from 'react';
import { Col, Grid } from 'mrf/view/Grid';
import Paper from 'mrf/view/Paper';
import Flex from 'mrf/layout/Flex';
import TextIcon from 'styles/basic/TextIcon';
import Text from 'styles/basic/Text';

export default function DashboardCard({ title, icon, children, disableGridGap, contentClassName = '' }) {    
    return (
        <Paper className='h-full'>
            <Grid gap={disableGridGap ? 0 : 4} className={contentClassName}>
                <Col size={12} component={Flex}>
                    {icon && <TextIcon icon={icon} size={6} />}
                    <Text>{title}</Text>
                </Col>
                {children}
            </Grid>
        </Paper>
    );
}
